import React, { PureComponent } from 'react'
import classNames from 'classnames'
import { isPlainObject, isArray } from 'lodash'
import styles from './Notification.module.scss'

class Notification extends PureComponent {
  getRootProps () {
    const { message } = this.props

    return {
      className: classNames({
        [styles.notification]: true,
        [styles.hide]: !message
      })
    }
  }

  renderMessage = message => {
    const { intl } = this.props

    if (isPlainObject(message)) {
      return intl.formatMessage(message)
    }

    if (isArray(message)) {
      return message.map(this.renderMessage).join(' ')
    }

    return message
  }

  render () {
    const { message } = this.props

    return <div {...this.getRootProps()}>{this.renderMessage(message)}</div>
  }
}

export default Notification
